export default "__VITE_ASSET__w1A5C0zQ__"